'use strict';

import React, { PropTypes } from 'react';
import PageControls from '../molecules/PageControls';
import DraftActionCreators from '../actions/DraftActionCreators';
import UserStore from '../stores/UserStore';
import Button from '../atoms/Button';
import Icon from '../atoms/Icon';
import BtnGroup from '../molecules/BtnGroup';
import PureRenderMixin from '../mixins/PureRenderMixin';
import ContextMenuActionCreators from '../actions/ContextMenuActionCreators';
import ContextMenuTypes from '../constants/ContextMenuTypes';
import parseStampSegment from '../utils/parseStampSegment';
import SidebarActionCreators from '../actions/SidebarActionCreators';
import SidebarTypes from '../constants/SidebarTypes';

const DraftPageControls = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    isUnlisted: PropTypes.bool.isRequired,
    isPublishing: PropTypes.bool.isRequired,
    canPublish: PropTypes.bool.isRequired,
    stampSegment: PropTypes.string.isRequired,
    showOptions: PropTypes.bool
  },

  render() {
    const { isPublishing, stampSegment, canPublish, children, isUnlisted, showOptions } = this.props;
    const { isDraft } = parseStampSegment(stampSegment);
    const isProAccount = UserStore.isAuthenticated() && UserStore.getMe().isProAccount;

    return (
      <PageControls context='Draft'>
        {showOptions &&
          <PageControls.Container fill>
            <BtnGroup>
              {isProAccount &&
                <Button onClick={this.handleSwitchStatusClick}
                        context='PageControls'
                        overlay
                        color='black'
                        size='medium'>
                  <Icon name={isUnlisted ? 'eyeCrossed' : 'eye'}
                        mode={isUnlisted ? 'fill' : 'stroke'}
                        size='small'/>
                  {isUnlisted ? 'Secret' : 'Public'}
                  <Icon name='arrowUp'
                        mode='stroke'
                        size='xsmall'
                        margin='left' />
                </Button>
              }
              <Button onClick={this.handleShowMoreClick}
                      context='PageControls'
                      overlay
                      color='black'
                      size='medium'
                      round>
                <Icon name='more' mode='fill' />
              </Button>
            </BtnGroup>
          </PageControls.Container>
        }

        <PageControls.Container>
          <BtnGroup>
            {children}
          </BtnGroup>

          <BtnGroup>
            {!isDraft && !isPublishing &&
              <Button size='medium'
                      overlay
                      split
                      color='black'
                      context='PageControls'
                      onClick={this.handleCancelClick}>
                Cancel
              </Button>
            }

            <Button color='green'
                    fill
                    split={!isDraft}
                    disabled={!canPublish}
                    onClick={this.handlePostClick}
                    context='PageControls'
                    size='medium'>
              {isDraft && !isPublishing &&
                'Post'
              }
              {isDraft && isPublishing &&
                'Posting...'
              }
              {!isDraft && !isPublishing &&
                'Save'
              }
              {!isDraft && isPublishing &&
                'Saving...'
              }
            </Button>
          </BtnGroup>
        </PageControls.Container>
      </PageControls>
    );
  },

  handleSwitchStatusClick(e) {
    const el = e.target;

    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.STAMP_STATUS_PICKER, el);
  },

  handleCancelClick() {
    DraftActionCreators.cancelEditingStamp();
  },

  handlePostClick() {
    DraftActionCreators.postOrUpdateStamp();
  },

  handleShowMoreClick(e) {
    const el = e.target;
    const { stampSegment } = this.props;

    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.EDITOR_MORE, el, {
      stampSegment
    });
  }
});

module.exports = DraftPageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/DraftPageControls.jsx
 **/